export default __webpack_public_path__ + "static/media/icons-history-18-px.598b7677.svg";